import React, { FC } from 'react'
import styled from 'styled-components'

import { Text } from '../CssStyled'

import QuoteIcon from './Quote'

interface IRecommendation {
  opinion: string
  author: string
}

const Recommendation: FC<IRecommendation> = ({ opinion, author }) => (
  <Container>
    <Content>
      <QuoteIconWrapper>
        <QuoteIcon />
      </QuoteIconWrapper>
      {opinion}
    </Content>
    <Author>{author}</Author>
  </Container>
)

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const Content = styled.span`
  position: relative;
  color: #71757d;
  font-family: 'Poppins';
  font-style: normal;
  font-size: 14px;
  line-height: 21px;
`

const QuoteIconWrapper = styled.div`
  position: absolute;
  left: -22px;
  top: -22px;
  z-index: -1;
`

const Author = styled(Text)`
  text-align: end;
`

export default Recommendation
